import { useQuery } from '@tanstack/react-query'

import { GetStatusDoProduto } from '@/features/produtos/services/get-status-do-produto.service'
import { produtosKeys } from '@/features/produtos/utils'

export const useStatusProduto = (idExternoProduto: number) => {
  return useQuery({
    queryKey: produtosKeys.status(idExternoProduto),
    queryFn: async () => new GetStatusDoProduto().execute(idExternoProduto).then((res) => res.data),
    enabled: false,
  })
}
